// src/pages/PaymentControlPanel.tsx
import React from 'react';
import {
    Container,
    Box,
} from '@mui/material';
import InfoPaymentSection from './components/PaymentsPanel/InfoPaymentsSection';
import FiltersPanelSection from './components/PaymentsPanel/FiltersPanelSection';
import PaymentsList from './components/PaymentsPanel/PaymentsList';
import PageHeader from '@/components/common/PageHeader';


const PaymentsPanel: React.FC = () => {
    return (
        <Box sx={{
            backgroundColor: '#F8F9FA',
            minHeight: '100vh',
            pb: { xs: 2, sm: 3, md: 4 },
            px: { xs: 2, md: 3, lg: 4 }
        }}>
            <Container maxWidth="xl">
                <PageHeader title="Panel de Control de Pagos" description="Visualiza y gestiona todo el historial de transacciones desde un solo lugar. Controla tus pagos, verifica estados y genera reportes para tu contabilidad." />
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    px: { xs: 0, md: 2, lg: 8 }
                }}>
                    <InfoPaymentSection />

                    {/* Filters Section */}
                    <FiltersPanelSection />

                    {/* Payments Table */}
                    <PaymentsList />
                </Box>

            </Container>
        </Box>
    );
};

export default PaymentsPanel;